module.exports = __webpack_public_path__ + "static/media/banner.20d1a8fd.mp4";